module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e57711"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_con6_r1#d7e2648",
      "id": "d14e458"
    }
  }, [_vm._v("INTRODUCTION"), _c('br'), _vm._v("\n  O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONNECT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e59111"
    }
  }, [_c('span', {
    staticClass: "ic",
    attrs: {
      "id": "d14e468"
    }
  }, [_vm._v("B")]), _c('i', [_vm._v("rooklyn Noir")]), _vm._v(" was a huge success, set a bunch of authors to write about one place, simple and highly effective.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e60611"
    }
  }, [_vm._v("Now in Akashic Books’ “noir” pipeline are Manhattan, Baltimore, Miami, Los Angeles, Havana, London … and that’s just the beginning. Here is "), _c('i', [_vm._v("Dublin Noir.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e62011"
    }
  }, [_vm._v("At first, it was straightforward—Dublin authors to write on their city … Then we turned the concept on its head, as you do in noir. The Irish are fascinated by how we appear to the world, so let’s have a look, we thought, at how this city appears from the outside. In addition to a couple of us locals, let’s take a cross section of the very best of today’s crime writers from America, as well as Britain, Europe, and Canada—the successful ones, the new blood, and those between. We knew we’d get a lot of Yeats and Ulysses, but what else … ?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e65311"
    }
  }, [_vm._v("The challenge we posed to the authors we invited to join this collection was simple: Show us "), _c('i', [_vm._v("your")]), _vm._v(" Dublin, and show it noir.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e66911"
    }
  }, [_vm._v("Tourists booking holidays in Ireland inevitably do Dublin first and seem to always end up in Temple Bar, our very own Times Square—replete with the squalor, the drugs, the homeless, and the wandering psychos. Two years ago, Pat Boran, the legendary director of the Dublin Arts Festival, invited me to do a reading in Temple Bar. During my gig, a woman up and died. It added to my already noir rep and has certainly given me pause about returning there. Temple Bar, naturally, features in many of the stories, and the authors certainly capture the noir element. The Tourist Board, not fond of me in the best of times, has responded with a bounty on my head. I take that, I think, as flattery.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e72012"
    }
  }, [_vm._v("Ireland’s alleged surging economy—the “Celtic Tiger”— has thrust Dublin onto the world stage, though here the city’s not exactly seen through rose-tinted glasses. Black Irish humor shines in all the stories, as if instinctively the writers knew: You want it Dublin, then you want it funny as sin, dark as the smile on Joyce’s face when he found he was on the index of banned books. To be Irish is to dance on the Titanic; laughter is indeed the best revenge, it’s our way of evening the score.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e75112"
    }
  }, [_vm._v("You won’t find many leprechauns or bodhrans here—and not one "), _c('i', [_vm._v("top o’ the mornin’.")]), _vm._v(" “The Quiet Man” has gone dark, and with a vengeance. If nothing else, this collection will kill stone-dead the Irish caricature of shite talk and blarney. In the days of Brit occupation, to be outside Dublin was to be outside the pale. This collection is so far from that parameter, you can’t even see the boundary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e78012"
    }
  }, [_vm._v("Like Irish logic at its most convoluted, this volume offers up a story that moves from Budapest to Dublin written by a Texan. In another, Ray Banks, from Manchester, England, presents a vision of Dublin as fierce as any Celt’s. One of the collection’s tastiest moments comes when Peter Spiegelman’s femme fatale tells his protagonist, “Yer pretty feckin’ Irish for a New York Jew, Jimmy—you’ll fit right in in Dublin.” The one guarantee from every story in this book is a skewed perspective on this most volatile of locales.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e81312"
    }
  }, [_vm._v("We set John Rickards, an impossibly young writer, loose in Dublin—a British mindset carried in an American style—to see what would happen. James O. Born, a Miami homicide detective, gives us a "), _c('i', [_vm._v("radical")]), _vm._v(" (to put it mildly) take on the Irish tourist industry. Laura Lippman and Sarah Weinman masterfully bust up our sketchy designs on an all-guy lineup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e84513"
    }
  }, [_vm._v("And how could we do this without the culchie take? … So we have the Galway view on Dublin, always going to be contentious. If nothing else, we knew it would make Nora Barnacle smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e86013"
    }
  }, [_vm._v("The dictum, "), _c('i', [_vm._v("Only connect,")]), _vm._v(" was brought home to me in Las Vegas. James Crumley, renowned mystery writer, asked, “Wouldn’t it be something to connect all these different countries, have them united in crime?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e88113"
    }
  }, [_vm._v("Dublin, locus of so many literary legends, seemed a fine place to connect some dots. Enjoy."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d7e89213"
    }
  }, [_c('i', [_vm._v("Ken Bruen"), _c('br'), _vm._v("\n  Galway, Ireland"), _c('br'), _vm._v("\n  January 2006")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5594776c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Brue_ISBN9781936070282_epub_ch2_r1.vue
// module id = 78
// module chunks = 0